import { canonicalUrlCleanup } from '../../utils/canonical-url-cleanup';
import { getOriginUrl } from '../../utils/url-utils';

export enum CanonicalCategory {
    PRODUCT = 'product',
    RECIPE = 'recipe',
    TRADITIONAL_GIFT_CARD = 'traditional-gift-card',
    ELECTRONIC_GIFT_CARD = 'electronic-gift-cards',
}

export interface GetCanonicalUrlProps {
    id: string;
    sku: string;
    category: CanonicalCategory;
}

export const sanitizeSegment = (segment: string): string => segment.trim();

export const getCanonicalUrl = ({ id, sku, category }: GetCanonicalUrlProps): string => {
    const originUrl = getOriginUrl();
    const pathSegments: string[] = [sanitizeSegment(category)];

    if (sku) {
        pathSegments.push(sanitizeSegment(sku));
    }

    if (id) {
        pathSegments.push(sanitizeSegment(id));
    }

    const relativePath = pathSegments.join('/');

    return canonicalUrlCleanup(`${originUrl}/${relativePath}`);
};
